var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRetinalMarketTrends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.537,
    height: 41.316,
    viewBox: "0 0 41.537 41.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.454,19.444c-.061.203-.213.271-.423.271-2.177-.002-4.353,0-6.53-.002-.287,0-.402-.11-.402-.381,0-2.075,0-4.149-.002-6.224,0-.178.058-.309.232-.385h.517c.269.036.54.064.807.109,2.884.477,5.208,2.703,5.686,5.448.05.286.077.576.115.865v.301Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.251,22.508c-.02.172-.034.344-.059.515-.139.944-.53,1.784-1.172,2.516-.125.143-.264.276-.402.409-.15.144-.283.133-.423-.031-.391-.459-.78-.919-1.17-1.378-.56-.66-1.121-1.32-1.681-1.98-.027-.032-.055-.063-.077-.098-.09-.139-.02-.296.147-.33.041-.009.085-.009.128-.009,1.463,0,2.926,0,4.389-.002.152,0,.264.043.32.185v.204Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.653,17.614c0,1.003-.003,2.005.004,3.007,0,.103.037.202.101.282,1.348,1.656,2.701,3.308,4.054,4.961.124.152.108.384-.045.508-.805.655-1.737,1.051-2.785,1.161-.482.051-.976.033-1.462.011-.705-.032-1.409-.165-2.066-.424-2.434-.957-3.963-2.652-4.412-5.112-.41-2.244.218-4.253,1.85-5.944.982-1.018,2.206-1.63,3.647-1.83.255-.035.515-.039.773-.048.188-.006.295.083.326.26.012.067.014.136.014.204,0,.988,0,1.976,0,2.964Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.255,20.135c.397-1.236,1.318-2.06,2.121-2.963,2.628-2.955,5.612-5.445,9.176-7.123,1.226-.577,2.525-1.014,3.864-1.223,4.597-.719,8.477.763,12.023,3.221,2.661,1.845,4.953,4.131,7.044,6.656.622.752.979,1.579.706,2.582-.092.338-.255.682-.467.952-2.557,3.257-5.488,6.053-9.024,8.086-1.893,1.089-3.893,1.855-6.032,2.181-.478.073-.961.11-1.441.161l-.871.005c-.294-.029-.588-.055-.881-.088-2.103-.236-4.087-.899-5.974-1.896-3.158-1.668-5.852-3.984-8.243-6.707-.761-.867-1.629-1.663-2.005-2.841l.004-1.004Z",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.65,8.409V3.53C.65,1.939,1.939.65,3.53.65h5.212",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.887,8.409V3.53c0-1.59-1.289-2.88-2.88-2.88h-5.212",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.887,32.906v4.879c0,1.59-1.289,2.88-2.88,2.88h-5.212",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.65,32.906v4.879c0,1.59,1.289,2.88,2.88,2.88h5.212",
    fill: "none",
    stroke: "#73307a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetinalMarketTrends);
export default __webpack_public_path__ + "static/media/Retinal-Market-Trends.03ed9376.svg";
export { ForwardRef as ReactComponent };